import { Link } from "react-router-dom";
import Header from "../components/Header";

export const DESTINATIONS = [
  { name: "Italy", tag: "Coastal serenity from Positano to the Amalfi Coast.", img: "/photos/dest-italy-como.jpg" },
  { name: "India", tag: "The birthplace of Ayurveda and yoga.", img: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800&q=80" },
  { name: "Indonesia", tag: "Bali rice terraces and jungle stillness.", img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800&q=80" },
  { name: "Spain", tag: "Mediterranean light and clinical wellness on the coast.", img: "/photos/dest-spain.jpg" },
  { name: "Switzerland", tag: "Alpine lakes and the home of longevity medicine.", img: "/photos/dest-switzerland.jpg" },
];
const AVATARS = [
  { name: "Traveler", desc: "Discover your people, your places, your practitioners." },
  { name: "Practitioner", desc: "Be found by the world's most discerning clients." },
  { name: "Retreat Leader", desc: "Assemble your dream team, anywhere in the world." },
  { name: "Host / Hotelier", desc: "Bring world-class wellness to your property." },
  { name: "Advisor / Agency", desc: "Craft elevated wellness itineraries clients remember." },
  { name: "Corporate / Enterprise", desc: "Wellbeing as a strategic advantage." },
  { name: "Brand / Product", desc: "Reach the world's most discerning wellness audience." },
  { name: "Creator", desc: "Storytellers of luxury wellness." },
  { name: "Services", desc: "Photographers, planners and production teams." },
  { name: "Events", desc: "Trade shows, gatherings and transformational events." },
  { name: "Speakers", desc: "Be booked for the stages that matter." },
  { name: "Consultants", desc: "Grow the business of wellness." },
];
const QUESTIONS = ["Who you are", "What you offer", "What you need", "Where you operate", "Who you should know", "What opportunity exists"];

export default function Welcome() {
  return (
    <div className="min-h-screen bg-bone text-ink" data-testid="welcome-page">
      <Header active="list" />
      <section className="pt-36 pb-10 px-6 lg:px-10 max-w-7xl mx-auto">
        <p className="text-5xl sm:text-6xl text-gold mb-2"><span className="font-sign">thank</span><span className="font-headline italic text-[0.62em] ml-2">you</span></p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">YOUR INVITATION IS ON ITS WAY</h1>
        <p className="mt-6 font-headline italic text-xl text-ink/70 max-w-2xl">While we prepare it, tell us a little more: where you are drawn to, and who you are.</p>
      </section>

      <section className="px-6 lg:px-10 max-w-7xl mx-auto py-14 border-t border-gold/30">
        <p className="eyebrow mb-2">Destinations</p>
        <h2 className="font-display text-3xl lg:text-4xl tracking-tight mb-1">DID SOMEBODY SAY EAT, PRAY, LOVE?</h2>
        <p className="font-headline italic text-base text-ink/55 mb-8">Begin with Italy, India and Indonesia.</p>
        <div className="grid sm:grid-cols-3 gap-6">
          {DESTINATIONS.map((d) => (
            <Link key={d.name} to="/list/dashboard" data-testid={`destination-${d.name.toLowerCase()}`} className="group relative aspect-[4/5] overflow-hidden block">
              <img src={d.img} alt={d.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1000ms] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 text-ivory">
                <h3 className="font-display text-2xl tracking-wide">{d.name}</h3>
                <p className="text-sm text-ivory/80 mt-1">{d.tag}</p>
                <span className="eyebrow !text-[0.55rem] !text-gold mt-3 inline-block">Explore →</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="px-6 lg:px-10 max-w-7xl mx-auto py-14 border-t border-gold/30">
        <p className="eyebrow mb-2">Find Your Place</p>
        <h2 className="font-display text-3xl lg:text-4xl tracking-tight mb-8">WHO ARE YOU?</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-gold/25 border border-gold/25">
          {AVATARS.map((a) => (
            <Link key={a.name} to="/list/dashboard" data-testid={`avatar-${a.name.split(" ")[0].toLowerCase()}`}
              className="group bg-ivory p-6 hover:bg-sage hover:text-ivory transition-colors block">
              <h3 className="font-headline text-xl group-hover:text-gold transition-colors">{a.name}</h3>
              <p className="text-xs text-ink/55 group-hover:text-ivory/70 mt-2 leading-relaxed transition-colors">{a.desc}</p>
            </Link>
          ))}
        </div>
        <div className="mt-10 pb-10">
          <p className="eyebrow mb-4">Every profile, read through six questions</p>
          <div className="grid sm:grid-cols-3 lg:grid-cols-6 gap-px bg-gold/25 border border-gold/25">
            {QUESTIONS.map((qq, i) => (
              <div key={qq} className="bg-ivory p-5"><p className="font-display text-3xl text-gold/40">{i + 1}</p><p className="text-xs mt-3 text-ink/70 uppercase tracking-wider">{qq}</p></div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
